/* eslint-disable jsx-a11y/alt-text */
import {useState, useEffect} from 'react'
import {Button, Modal} from 'react-bootstrap'
import '../Overview.css'
import UserService from '../../../../../services/user'
import MasterServices from '../../../../../services/master'
import useServices from '../../../../../utils/hooks/useServices'
import FormDescription from './FormDescription'
import FormOther from './FormOther'
import {useSearchParams} from 'react-router-dom'
import FormPersonal from './FormPersonal'
import FormAddressDomicile from './FormAddressDomicile'
import {PageTitle} from '_metronic/layout/core'

import {dateFormat} from '../../../../../thesis-and-dissertations/helpers/helper'

const PersonalInformation = () => {
  const [searchParams] = useSearchParams()
  const [data, setData] = useState<any>({})
  const [dataUser, loading, isError, triggerRefresh] = useServices(
    searchParams.get('alumni') ? MasterServices.showUser : UserService.getProfile,
    searchParams.get('alumni')
  )
  const [showModal, setShowModal] = useState<any>({
    modalDescription: false,
    modalOther: false,
    modalPersonal: false,
    modalAddressDomicile: false,
  })

  useEffect(() => {
    if (searchParams.get('alumni')) {
      setData(dataUser?.data)
    } else {
      setData(dataUser)
    }
  }, [dataUser])

  const toggle = () => {
    if (showModal.modalDescription) {
      setShowModal({...showModal, modalDescription: !showModal.modalDescription})
    }

    if (showModal.modalOther) {
      setShowModal({...showModal, modalOther: !showModal.modalOther})
    }

    if (showModal.modalPersonal) {
      setShowModal({...showModal, modalPersonal: !showModal.modalPersonal})
    }

    if (showModal.modalAddressDomicile) {
      setShowModal({...showModal, modalAddressDomicile: !showModal.modalAddressDomicile})
    }
  }

  const handleShowModal = (name: string, value: boolean) => {
    setShowModal({...showModal, [name]: value})
  }

  return (
    <div className='d-grid gap-10'>
      <Modal show={showModal.modalDescription} onHide={toggle} size='lg'>
        <Modal.Header closeButton>
          <Modal.Title>Edit Deskripsi Singkat</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormDescription
            toggle={toggle}
            getData={triggerRefresh}
            editFormValue={data}
            loading={loading}
          />
        </Modal.Body>
      </Modal>

      <Modal show={showModal.modalOther} onHide={toggle} size='lg'>
        <Modal.Header closeButton>
          <Modal.Title>Edit Lainnya</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormOther
            toggle={toggle}
            getData={triggerRefresh}
            editFormValue={data}
            loading={loading}
          />
        </Modal.Body>
      </Modal>

      <Modal show={showModal.modalPersonal} onHide={toggle} size='lg'>
        <Modal.Header closeButton>
          <Modal.Title>Edit Informasi Personal</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormPersonal
            toggle={toggle}
            getData={triggerRefresh}
            editFormValue={data}
            loading={loading}
          />
        </Modal.Body>
      </Modal>

      <Modal show={showModal.modalAddressDomicile} onHide={toggle} size='lg'>
        <Modal.Header closeButton>
          <Modal.Title>Edit Alamat Domisili</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormAddressDomicile
            toggle={toggle}
            getData={triggerRefresh}
            editFormValue={data}
            loading={loading}
          />
        </Modal.Body>
      </Modal>
      {localStorage.getItem('role') == 'Alumni' && (
        <PageTitle
          breadcrumbs={[
            {
              title: 'Dashboard',
              path: '/dashboard',
              isSeparator: false,
              isActive: false,
            },
            {
              title: '/',
              path: '',
              isSeparator: false,
              isActive: false,
            },
          ]}
        >
          Informasi Personal
        </PageTitle>
      )}
      <h4> Informasi Personal</h4>
      <div className='row d-grid gap-10'>
        <div className='col-md-12'>
          <div className='card-custom'>
            <div className='d-grid gap-4'>
              <div className='row'>
                <div className='col-md-6 p-2'>
                  <h5>Deskripsi Singkat</h5>
                </div>
                <div className='col-md-6'>
                  {!searchParams.get('alumni') && (
                    <Button
                      onClick={() => handleShowModal('modalDescription', true)}
                      style={{marginTop: '-15px', float: 'right'}}
                      className='btn-sm'
                    >
                      Edit
                    </Button>
                  )}
                </div>
                <div className='col-md-12 p-2'>
                  <p> {data?.detail?.user_details_description ?? '-'} </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* start data personal */}
        <div className='col-md-12'>
          <div className='card-custom'>
            <div className='row d-grid gap-4'>
              <div className='col-md-12'>
                <div className='row'>
                  <div className='col-md-6 p-2'>
                    <h5>DATA PERSONAL</h5>
                  </div>
                  <div className='col-md-6'>
                    {!searchParams.get('alumni') && (
                      <Button
                        onClick={() => handleShowModal('modalPersonal', true)}
                        style={{marginTop: '-15px', float: 'right'}}
                        className='btn-sm'
                      >
                        Edit
                      </Button>
                    )}
                  </div>
                  <div className='col-md-12'>
                    <div className='row'>
                      <div className='col-md-6 p-2'>
                        <p>NIK</p>
                        <p className='fw-bold'>
                          {data?.detail?.user_details_id_card_number ?? '-'}
                        </p>
                      </div>
                      <div className='col-md-6 p-2'>
                        <p>NPWP</p>
                        <p className='fw-bold'>{data?.detail?.user_details_tax_id_number ?? '-'}</p>
                      </div>
                      <div className='col-md-6 p-2'>
                        <p>Tanggal Lahir</p>
                        <p className='fw-bold'>{data?.detail?.dob ? dateFormat(data?.detail?.dob) : '-'}</p>
                      </div>
                      <div className='col-md-6 p-2'>
                        <p>Jenis Kelamin</p>
                        <p className='fw-bold'>
                          {data?.detail
                            ? data?.detail?.user_details_gender == 1
                              ? 'Pria'
                              : 'Wanita'
                            : ''}
                        </p>
                      </div>
                      <div className='col-md-6 p-2'>
                        <p>No. Handphone & Whatsapp</p>
                        <p className='fw-bold'>
                          {data?.detail
                            ? `+${data?.detail.user_details_code_phone}  ${data?.detail.user_details_phone}`
                            : '-'}
                        </p>
                      </div>
                      <div className='col-md-6 p-2'>
                        <p>Email Terdaftar</p>
                        <p className='fw-bold'>{data ? data?.email ?? '-' : '-'}</p>
                      </div>
                      <div className='col-md-6 p-2'>
                        <p>Email Alternatif</p>
                        <p className='fw-bold'>{data?.detail?.alternative_email ?? '-'}</p>
                      </div>
                      <div className='col-md-6 p-2'>
                        <p>Status Pekerjaan</p>
                        <p className='fw-bold'>
                          {data?.detail?.is_kerja == 1 ? 'Sudah Bekerja' : 'Belum Bekerja'}
                        </p>
                      </div>
                      <div className='col-md-6 p-2'>
                        <p>Rekening (Diutamakan Mandiri)</p>
                        <p className='fw-bold'>{data?.detail?.no_rekening ?? '-'}</p>
                      </div>
                      <div className='col-md-6 p-2'>
                        <p>Nama Sesuai Rekening</p>
                        <p className='fw-bold'>{data?.detail?.nama_rekening ?? '-'}</p>
                      </div>
                      <div className='col-md-6 p-2'>
                        <p>Nama Bank</p>
                        <p className='fw-bold'>{data?.detail?.nama_bank ?? '-'}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* end data personal */}

        {/* start data alamat */}
        {data?.addresses?.map((item: any, key: any) => {
          return (
            item?.user_addresses_is_domicile == 0 && (
              <div className='col-md-12' key={key}>
                <div className='card-custom'>
                  <div className='row d-grid gap-4'>
                    <div className='col-md-12'>
                      <div className='row'>
                        <div className='col-md-6 p-2'>
                          <h5>DATA ALAMAT KTP</h5>
                        </div>
                      </div>
                    </div>
                    <div className='col-md-12'>
                      <div className='row'>
                        <div className='col-md-12 p-2'>
                          <p>Alamat KTP</p>
                          <p>
                            {item?.user_addresses_is_domicile == 0
                              ? item?.user_addresses ?? '-'
                              : '-'}
                          </p>
                        </div>
                        <div className='col-md-6 p-2'>
                          <p>Negara</p>
                          <p className='fw-bold'>
                            {item?.user_addresses_is_domicile == 0
                              ? item?.province?.country?.countries_name
                              : '-'}
                          </p>
                        </div>
                        <div className='col-md-6 p-2'>
                          <p>Provinsi</p>
                          <p className='fw-bold'>
                            {item?.user_addresses_is_domicile == 0
                              ? item?.province?.provinces_name
                              : '-'}
                          </p>
                        </div>
                        <div className='col-md-6 p-2'>
                          <p>Kabupaten/Kota</p>
                          <p className='fw-bold'>
                            {item?.user_addresses_is_domicile == 0 ? item?.city?.cities_name : '-'}
                          </p>
                        </div>

                        <div className='col-md-6 p-2'>
                          <p>Kecamatan</p>
                          <p className='fw-bold'>
                            {item?.user_addresses_is_domicile == 0
                              ? item?.district?.districts_name
                              : '-'}
                          </p>
                        </div>

                        <div className='col-md-6 p-2'>
                          <p>Kelurahan/Desa</p>
                          <p className='fw-bold'>
                            {item?.user_addresses_is_domicile == 0
                              ? item?.village?.villages_name
                              : '-'}
                          </p>
                        </div>
                        <div className='col-md-6 p-2'>
                          <p>Kode POS</p>
                          <p className='fw-bold'>
                            {item?.user_addresses_is_domicile == 0
                              ? item?.user_addresses_postal_code
                              : '-'}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          )
        })}

        {data?.addresses?.map((item: any, key: any) => {
          return (
            item?.user_addresses_is_domicile == 1 && (
              <div className='col-md-12' key={key}>
                <div className='card-custom'>
                  <div className='row d-grid gap-4'>
                    <div className='col-md-12'>
                      <div className='row'>
                        <div className='col-md-6 p-2'>
                          <h5>DATA ALAMAT DOMISILI</h5>
                        </div>
                        <div className='col-md-6'>
                          {!searchParams.get('alumni') && (
                            <Button
                              onClick={() => handleShowModal('modalAddressDomicile', true)}
                              style={{marginTop: '-15px', float: 'right'}}
                              className='btn-sm'
                            >
                              Edit
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className='col-md-12'>
                      <div className='row'>
                        <div className='col-md-12 p-2'>
                          <p>Alamat Domisili</p>
                          <p className='fw-bold'>
                            {item.user_addresses_is_domicile == 1
                              ? item.user_addresses ?? '-'
                              : '-'}
                          </p>
                        </div>
                        <div className='col-md-6 p-2'>
                          <p>Negara</p>
                          <p className='fw-bold'>
                            {item.user_addresses_is_domicile == 1
                              ? item.province?.country?.countries_name
                              : '-'}
                          </p>
                        </div>
                        <div className='col-md-6 p-2'>
                          <p>Provinsi</p>
                          <p className='fw-bold'>
                            {item?.user_addresses_is_domicile == 1
                              ? item?.province?.provinces_name
                              : '-'}
                          </p>
                        </div>
                        <div className='col-md-6 p-2'>
                          <p>Kabupaten/Kota</p>
                          <p className='fw-bold'>
                            {item?.user_addresses_is_domicile == 1 ? item?.city?.cities_name : '-'}
                          </p>
                        </div>

                        <div className='col-md-6 p-2'>
                          <p>Kecamatan</p>
                          <p className='fw-bold'>
                            {item?.user_addresses_is_domicile == 1
                              ? item?.district?.districts_name
                              : '-'}
                          </p>
                        </div>

                        <div className='col-md-6 p-2'>
                          <p>Kelurahan/Desa</p>
                          <p className='fw-bold'>
                            {item?.user_addresses_is_domicile == 1
                              ? item?.village?.villages_name
                              : '-'}
                          </p>
                        </div>
                        <div className='col-md-6 p-2'>
                          <p>Kode POS</p>
                          <p className='fw-bold'>
                            {item.user_addresses_is_domicile == 1
                              ? item.user_addresses_postal_code
                              : '-'}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          )
        })}
        {/* end data alamat */}
        {/* end content */}

        {/* start data lainnya */}
        <div className='col-md-12'>
          <div className='card-custom'>
            <div className='row d-grid gap-4'>
              <div className='col-md-12 p-2'>
                <div className='row'>
                  <div className='col-md-6'>
                    <h5>LAINNYA</h5>
                  </div>
                  <div className='col-md-6'>
                    {!searchParams.get('alumni') && (
                      <Button
                        onClick={() => handleShowModal('modalOther', true)}
                        style={{marginTop: '-15px', float: 'right'}}
                        className='btn-sm'
                      >
                        Edit
                      </Button>
                    )}
                  </div>
                </div>
              </div>

              <div className='col-md-12'>
                <div className='row'>
                  <div className='col-md-6 p-2'>
                    <p>Email Alternatif</p>
                    <p className='fw-bold'>{data?.detail?.alternative_email ?? '-'}</p>
                  </div>

                  <div className='col-md-6 p-2'>
                    <p>No. Handphone Alternatif</p>
                    <p className='fw-bold'>
                      {data?.detail
                        ? `+${data?.detail.user_details_wa_code_phone}  ${data?.detail.user_details_wa_phone}`
                        : '-'}
                    </p>
                  </div>

                  <div className='col-md-6 p-2'>
                    <p>Facebook</p>
                    <p className='fw-bold'>
                      {data?.detail ? data?.detail.user_details_fb ?? '-' : '-'}
                    </p>
                  </div>

                  <div className='col-md-6 p-2'>
                    <p>Twitter</p>
                    <p className='fw-bold'>
                      {data?.detail ? data?.detail?.user_details_twitter ?? '-' : '-'}
                    </p>
                  </div>

                  <div className='col-md-6 p-2'>
                    <p>Instagram</p>
                    <p className='fw-bold'>
                      {data?.detail ? data?.detail?.user_details_ig ?? '-' : '-'}
                    </p>
                  </div>

                  <div className='col-md-6 p-2'>
                    <p>Youtube</p>
                    <p className='fw-bold'>
                      {data?.detail ? data?.detail?.user_details_youtube ?? '-' : '-'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* end data lainnya */}
      </div>
    </div>
  )
}

export default PersonalInformation
